/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './America250Promo.scss';

import { Button } from 'sarsaparilla';

import backgroundImageSrc from './images/america-250-background.webp';

export function America250Promo() {
    return (
        <div className="nav--america-250-promo">
            <div className="image-group">
                <img src={backgroundImageSrc} alt="" className="image" />
            </div>

            <div className="overlay" />
            <div className="overlay-shader" />

            <div className="content">
                <h2>Celebrate 250 Years of American Discovery</h2>
                <p>
                    Explore historic parks, cultural sites, scenic landscapes, and more as
                    you join the nationwide celebration of America‘s 250th anniversary.
                    Find places where the past comes alive, and plan your next
                    unforgettable outdoor experience!
                </p>

                <Button
                    className="learn-more-button"
                    appearance="tertiary-white"
                    aria-label="Learn more about Freedom 250"
                    href="/articles/location-spotlight/Celebrating-America's-250th-Anniversary/1367"
                    gaReportName="Featured promo for Freedom 250"
                    gaReportCreative="featured promo for Freedom 250"
                    gaReportPosition="HomePage"
                    shouldReportToGA
                >
                    Learn More
                </Button>
            </div>
        </div>
    );
}
